export const transformToFormData = entity => {
	const fd = new FormData();
	Object.keys(entity).forEach(k => {
		let value = entity[k];
		if (value) {
			if (Array.isArray(value) || value.constructor.name === 'Object') {
				value = JSON.stringify(value);
			}
			fd.append(k, value);
		}
	});
	return fd;
};
